export default __webpack_public_path__ + "static/media/KZ.T.19.2320 black.b8eb3c4d.svg";